import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heroImage: { id: 'Hero image', defaultMessage: 'Hero image' },
  button: { id: 'Button', defaultMessage: 'Button' },
  title: { id: 'Title', defaultMessage: 'Title' },
  description: { id: 'Description', defaultMessage: 'Description' },
  buttonLabel: { id: 'Button Label', defaultMessage: 'Button Label' },
  linkUrl: { id: 'Link URL', defaultMessage: 'Link URL' },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
});

export const schema = ({ intl }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.heroImage),
        fields: ['title', 'description'],
      },
      {
        id: 'button',
        title: intl.formatMessage(messages.button),
        fields: ['label', 'href', 'openLinkInNewTab'],
      },
    ],
    properties: {
      title: { title: intl.formatMessage(messages.title) },
      description: {
        title: intl.formatMessage(messages.description),
        widget: 'textarea',
      },
      label: { title: intl.formatMessage(messages.buttonLabel) },
      href: {
        title: intl.formatMessage(messages.linkUrl),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title'],
        allowExternals: true,
      },
      openLinkInNewTab: {
        title: intl.formatMessage(messages.openLinkInNewTab),
        type: 'boolean',
      },
    },
  };
};

export default schema;
